<template>
    <div class="container pb-5">
  <div class="px-4 py-5 text-center text-light h-50">
    <h2 class="display-4 fw-bold">API Central</h2>
    <div class="col-lg-6 mx-auto">
      <p class="lead mb-4">This site has been put together using <code>Vue</code>. The site consumes multiple APIs using <code>Fetch</code> and displays them using various suites.</p>
      <p>Vue | Vue-Router | Vuetify | NodeJS - NPM | Bootstrap | Bootstrap Icons</p>
      <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-5">
        <button type="button" class="btn btn-outline-secondary btn-lg px-4">API Central</button>
        <a href="/files/apicentral.apk" download="instaman.apk"><img src="../assets/img/logos/play.png" alt="download android app" width="48" height="48"></a>
      </div>
    </div>
    <div class="overflow-hidden">
      <div class="container px-5">
        <a href="https://apicentral.saqibofficial.com" target="_blank"><img src="../assets/img/apicentralpolicev2thumbnail.png" class="img-fluid border rounded-3 shadow-lg mb-4" alt="API Cental Police v2 site" width="700" height="900" loading="lazy"></a>      </div>
    </div>
  </div>
</div>
</template>